"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _activePortal = require("../activePortal");

var _linkedPortalsInformationList = require("./linked-portals-information-list.actions");

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _linkedPortalsInformationList.GET_LINKED_PORTALS_SUCCESS:
      {
        return action.body.portals;
      }

    case _activePortal.CHANGE_ACTIVE_PORTAL:
    case _linkedPortalsInformationList.GET_LINKED_PORTALS_ERROR:
      {
        return {};
      }

    default:
      {
        return state;
      }
  }
};

exports["default"] = _default;